import React from "react";
import PropTypes from "prop-types";
import RtrToggle from "components/design-system/rtr-toggle";
import { useSelector } from "react-redux";
import { isStorefrontNext } from "helpers/environment-helpers";
import AvailabilityFilterHelpers from "helpers/availability-filter-helpers";
import { availabilityFilter } from "rtr-constants";
import QuestionMark from "images/sprites/reb/svg/question-mark.svg";
import Tooltip from "components/design-system/tooltip";
import classNames from "classnames";

const GridAvailabilityToggle = ({ updateAvailabilityFilters, isShortlistGrid }) => {
  const workingFilters = useSelector(state => state.workingFilters) || {};
  const userData = useSelector(state => state.userData) || {};

  const isViewingAvailableProducts = () => {
    if (isStorefrontNext()) {
      return workingFilters.availableOnly;
    } else {
      return AvailabilityFilterHelpers.membershipMinAvailability(userData, workingFilters);
    }
  };

  const toggleAvailability = () => {
    const newFilter = isViewingAvailableProducts() ? availabilityFilter.allStyles : availabilityFilter.shipsDefault;

    updateAvailabilityFilters(newFilter);
  };

  const getInnerTooltipContent = () => {
    return userData.isClassicLens ? (
      <>
        <div className="mb-3">Browse with subscription to view items available now.</div>
        <button onClick={() => updateAvailabilityFilters(availabilityFilter.shipsDefault)} className="underline">
          Browse Subscription
        </button>
      </>
    ) : (
      <>
        <div className="mb-3">Toggle on to display items currently available to rent with subscription.</div>
        <a href="/clothing-subscription" className="underline">
          How It Works
        </a>
      </>
    );
  };

  const tooltipAnchor = <QuestionMark />;

  const tooltipContent = (
    <div className="text-black p-4 w-72 flex flex-col align-center text-center">{getInnerTooltipContent()}</div>
  );

  const classes = classNames("basis-1/2", "flex", "items-center", "justify-start", {
    "md:basis-1/3": !isShortlistGrid,
  });

  const checked = isViewingAvailableProducts() && !userData.isClassicLens;
  const heapId = checked ? "grid-availability-toggle-enabled" : "grid-availability-toggle-disabled";

  return (
    <div className={classes}>
      <RtrToggle
        labelText="Available Now"
        checked={checked}
        disabled={userData.isClassicLens}
        dataHeapId={heapId}
        onChange={toggleAvailability}
      />
      <div>
        <Tooltip anchorElement={tooltipAnchor} position="top" tooltipContent={tooltipContent} />
      </div>
    </div>
  );
};

GridAvailabilityToggle.propTypes = {
  isShortlistGrid: PropTypes.bool,
  updateAvailabilityFilters: PropTypes.func.isRequired,
};

export default GridAvailabilityToggle;
